export const LOCALE = 'en-US';
export const DEFAULT_TIMEZONE = 'UTC';
